<template>
  <button :disabled="disabled" type="reset">Reset</button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'the-reset-button',
  computed: {
    disabled() {
      return this.$store.getters.isStateEmpty;
    },
  },
});
</script>

<style lang="scss" scoped>
button {
  border: none;
  border-radius: 0.3rem;

  background-color: $primary-cyan;

  font-family: inherit;
  text-transform: uppercase;
  font-weight: 700;
  color: $darkest-cyan;

  margin-top: auto;
  padding: 0.5rem 0;

  transition: all 0.2s;

  &:active {
    background-color: lighten($color: $primary-cyan, $amount: 30);
  }

  &:disabled {
    background-color: hsl(183, 79%, 24%);
    color: rgba($color: $darkest-cyan, $alpha: 0.4);
  }
}
</style>
